import React from "react";
import { Trash2, AlertTriangle, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "../layout/header/Navbar";
import Footer from "../layout/footer/Footer";
import DeleteAccountForm from "./DeleteAccountForm";

export default function DeleteAccount() {
  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Navbar />

      <div style={{ flex: 1, paddingTop: "120px", paddingBottom: "80px" }}>
        <div className="container">
          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              color: "#64748b",
              fontSize: "0.88rem",
              fontWeight: 600,
              textDecoration: "none",
              marginBottom: "24px",
            }}
          >
            <ArrowLeft size={16} /> Back to EMIBOOK Home
          </Link>

          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "24px",
                  padding: "40px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 20px 45px -10px rgba(0, 0, 0, 0.08)",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "16px",
                    background: "rgba(239, 68, 68, 0.1)",
                    color: "#ef4444",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px auto",
                  }}
                >
                  <Trash2 size={28} />
                </div>

                <h1
                  style={{
                    fontFamily: "var(--font-primary)",
                    fontSize: "1.85rem",
                    fontWeight: 800,
                    color: "#0f172a",
                    marginBottom: "12px",
                  }}
                >
                  Account Deletion Request
                </h1>

                <p
                  style={{
                    color: "#64748b",
                    fontSize: "1rem",
                    lineHeight: 1.6,
                    marginBottom: "28px",
                  }}
                >
                  We are committed to your data privacy. If you wish to permanently delete your EMIBOOK account and associated records, you can submit an official request below.
                </p>

                <div
                  style={{
                    background: "rgba(245, 158, 11, 0.08)",
                    border: "1px solid rgba(245, 158, 11, 0.3)",
                    borderRadius: "16px",
                    padding: "16px 20px",
                    textAlign: "left",
                    marginBottom: "32px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                  }}
                >
                  <AlertTriangle size={20} color="#f59e0b" style={{ flexShrink: 0, marginTop: "2px" }} />
                  <div style={{ fontSize: "0.88rem", color: "#92400e" }}>
                    <strong>Please note:</strong> Deleting your account will remove your borrower registries, EMI timelines, and transaction history. This action cannot be undone once processed.
                  </div>
                </div>

                <DeleteAccountForm />

                <div style={{ marginTop: "24px", fontSize: "0.85rem", color: "#94a3b8" }}>
                  Need help instead? Contact us at{" "}
                  <a href="mailto:support@emibook.in" style={{ color: "#2563eb" }}>
                    support@emibook.in
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
